import { render } from "./Notificacao.vue?vue&type=template&id=916800ee"
const script = {}
script.render = render

export default script